var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({staticClass:"my-text-field inputNumber text-xs-right no-padding",attrs:{"value":_vm.value,"type":"number","maxlength":"3","hide-details":"","dense":"","single-line":"","oninput":"javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }